// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___HpxK","col":"styles_col__3o07p"};